<div id="wrapper">
  <nav class="navbar sticky-top navbar-expand-xl navbar-dark">

    <div id="navbarContainer" class="container-fluid">
      <div class="row justify-content-center">

        <button class="navbar-toggler ml-auto p-1 m-0" id="toggler-button" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler"
          aria-expanded="false" aria-label="Toggle navigation" i18n-aria-label>
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse text-center justify-content-center" data-bs-toggle="collapse" data-bs-target="#navbarToggler.show" id="navbarToggler">
          <a id="menulogo" data-bs-toggle="tooltip" data-placement="top" title="Startseite" routerLink="/home" routerLinkActive="router-link-active"
            aria-label="Zur Startseite von AlbCode" i18n-aria-label i18n-title>
            <img src="/logos/AlbCodeLogo_white.png" alt="AlbCode Logo" i18n-alt>
          </a>
          <app-navigate-back ngSkipHydration id="back" class="nav-item active p-0"
            [ngClass]="location.isCurrentPathEqualTo('/') ? 'backInvisible': 'backVisible' "></app-navigate-back>

          <ul id="navBar" class="navbar-nav mt-lg-0 col-auto">
            <li class="nav-item active dropdown">
              <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" routerLink="/albcode/about" routerLinkActive="router-link-active" role="button" aria-haspopup="true"
                aria-expanded="false" i18n>AlbCode & Leistungen</a>
              <div class="dropdown-menu">
                <a class="dropdown-item" routerLink="/albcode/about" routerLinkActive="router-link-active" i18n>Unternehmen</a>
                <a class="dropdown-item" routerLink="/albcode/webportale" routerLinkActive="router-link-active" i18n>Webportale</a>
                <a class="dropdown-item" routerLink="/albcode/softwaremodernisierung" routerLinkActive="router-link-active" i18n>Softwaremodernisierung</a>
                <a class="dropdown-item" routerLink="/albcode/typo3-webseiten" routerLinkActive="router-link-active" i18n>TYPO3-Webseiten & Pflege</a>
                <a class="dropdown-item" routerLink="/albcode/ki-agenten" routerLinkActive="router-link-active" i18n>KI & KI-Agenten</a>
                <a class="dropdown-item" routerLink="/albcode/referenzen" routerLinkActive="router-link-active" i18n>Referenzen</a>
                <a class="dropdown-item" routerLink="/albcode/crm" routerLinkActive="router-link-active" i18n>CRM-System</a>
                <a class="dropdown-item" routerLink="/albcode/immobilienverwaltung" routerLinkActive="router-link-active" i18n>Immobilienverwaltung</a>
                <a class="dropdown-item" routerLink="/albcode/techblog/list" routerLinkActive="router-link-active" i18n>Tech-Blog</a>
                <a class="dropdown-item" routerLink="/albcode/faq" routerLinkActive="router-link-active" i18n>Häufig gestellte Fragen (FAQ)</a>
              </div>
            </li>
            <li class="nav-item active dropdown">
              <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" routerLink="/partner/software" routerLinkActive="router-link-active" role="button" aria-haspopup="true"
                aria-expanded="false" i18n>Partner</a>
              <div class="dropdown-menu">
                <a class="dropdown-item" routerLink="/partner/software" routerLinkActive="router-link-active" i18n>Software-Partner</a>
                <a class="dropdown-item" routerLink="/partner/unternehmen" routerLinkActive="router-link-active" i18n>Partner-Unternehmen</a>
              </div>
            </li>
            <li class="nav-item active">
              <a class="nav-link" routerLink="/ticketsystem" routerLinkActive="active" i18n>Ticketsystem</a>
            </li>
            <li class="nav-item active">
              <a class="nav-link" routerLink="/contact" routerLinkActive="active" i18n>Kontakt & Anfahrt</a>
            </li>

            <li class="nav-item language-switcher" aria-label="Sprache wählen" i18n-aria-label>
              <a [href]="languageUrl('de')" lang="de" hreflang="de" aria-label="Deutsch" title="Deutsch"
                [attr.aria-current]="activeLocale === 'de' ? 'page' : null" [class.active]="activeLocale === 'de'">
                <span class="language-flag" aria-hidden="true">🇩🇪</span>
              </a>
              <span aria-hidden="true">/</span>
              <a [href]="languageUrl('en')" lang="en" hreflang="en" aria-label="English" title="English"
                [attr.aria-current]="activeLocale === 'en' ? 'page' : null" [class.active]="activeLocale === 'en'">
                <span class="language-flag" aria-hidden="true">🇬🇧</span>
              </a>
            </li>

            <div id="socialMenu">
              <li class="nav-item active p-0">
                <a href="https://www.facebook.com/profile.php?id=61553016423239" class="nav-link" target="_blank" rel="noopener noreferrer" aria-label="AlbCode auf Facebook"
                  data-toggle="tooltip" data-placement="top" title="Facebook" i18n-title i18n-aria-label><i class="fab fa-facebook fa-lg"></i></a>
              </li>
              <li class="nav-item active p-0">
                <a href="https://www.instagram.com/albcode.de/" class="nav-link" target="_blank" rel="noopener noreferrer" aria-label="AlbCode auf Instagram" data-toggle="tooltip"
                  data-placement="top" title="Instagram" i18n-title i18n-aria-label><i class="fa-brands fa-square-instagram fa-lg"></i></a>
              </li>
              <li class="nav-item active p-0">
                <a href="https://www.linkedin.com/company/100423046" class="nav-link" target="_blank" rel="noopener noreferrer" aria-label="AlbCode auf LinkedIn"
                  data-toggle="tooltip" data-placement="top" title="Linkedin" i18n-title i18n-aria-label><i class="fa-brands fa-linkedin fa-lg"></i></a>
              </li>
            </div>

          </ul>
        </div>
      </div>
    </div>
  </nav>

  <main id="main-content" class="content" (click)="closeToggleMenu();">
    <h1 class="visually-hidden">{{ pageHeading }}</h1>
    <router-outlet (activate)="onActivate()"></router-outlet>

    <!-- Footer -->
    <div id="footer-wrapper">
      @if (!location.isCurrentPathEqualTo('/contact')) {
      <app-contact-footer></app-contact-footer>
      }
      <div id="copyright" class="container">
        <ul class="menu">
          <li i18n>&copy; AlbCode. All rights reserved.</li>
          <li><a [routerLink]="['/impressum']" i18n>Impressum</a></li>
          <li><a [routerLink]="['/datenschutz']" i18n>Datenschutz</a></li>
        </ul>
      </div>
    </div>
  </main>
</div>
